<template>
  <router-view />

  <CensusConfirmQuit />
</template>

<script setup>
import CensusConfirmQuit from "./components/recensement-modals/CensusConfirmQuit.vue";
</script>
<style lang="scss">
@import "./assets/css/_variables.scss";

@font-face {
  font-family: "NunitoSans";
  src: local("NunitoSans"),
   url(./assets/fonts/NunitoSans-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "NunitoSemiBold";
  src: local("NunitoSemiBold"),
   url(./assets/fonts/NunitoSans-SemiBold.ttf) format("truetype");
}
@font-face {
  font-family: "NunitoSansBold";
  src: local("NunitoSansBold"),
   url(./assets/fonts/NunitoSans-Bold.ttf) format("truetype");
}
@font-face {
  font-family: "NunitoSansExtraBold";
  src: local("NunitoSansExtraBold"),
   url(./assets/fonts/NunitoSans-ExtraBold.ttf) format("truetype");
}
@font-face {
  font-family: "NunitoSansLight";
  src: local("NunitoSansLight"),
   url(./assets/fonts/NunitoSans-Light.ttf) format("truetype");
}
@font-face {
  font-family: "NunitoSansExtraLight";
  src: local("NunitoSansExtraLight"),
   url(./assets/fonts/NunitoSans-ExtraLight.ttf) format("truetype");
}
div{
  font-family: 'NunitoSans';
}
h2{
  font-family: 'NunitoSansExtraLight';
  font-size: 30px;
}
h3{
  font-family: 'NunitoSansExtraBold';
  font-size: 30px;
  color: $primary;
}
h4{
  font-family: 'NunitoSansBold';
  font-size: 26px;
  color: $black;
}
p{
  font-family: 'NunitoSans';
}
strong{
  font-family: 'NunitoSansBold',
}
.error{
  font-family: 'NunitoSemiBold';
  color: red;
}
.list{
  label{
    font-size: 16px;
    font-family: 'NunitoSemiBold';
    word-wrap: break-word;
  }
}
th{
  font-family: 'NunitoSansBold',
}

@media screen and (max-width: 1280px)
{
  .list{
    label{
      font-size: 0.8em;
      font-family: 'NunitoSemiBold';
    }
  }
}
</style>
